import React, { useState } from 'react'
import { compose } from 'recompose'
import { Button, Spin, message } from 'antd'
import { injectIntl, FormattedMessage } from 'react-intl'
import _get from 'lodash/get'
import useOmiseOffsite from '~/App/hooks/useOmiseOffsite'
import TruemoneyModal from './TruemoneyModal'
import { Block } from '../styles'

const OmiseTruemoney = compose(
  injectIntl
)(({ intl, registration, discounted, gatewayRate, gatewaySettings, systemFee, totalSystemFee, itemsDiscounted }) => {
  const publicKey = _get(gatewaySettings, 'publicKey', process.env.REACT_APP_OMISE_PUBLIC_KEY) || process.env.REACT_APP_OMISE_PUBLIC_KEY
  const totalAmount = discounted + itemsDiscounted
  const fee = Math.round(gatewayRate * discounted * 100) / 100
  const finalAmount = totalAmount + fee

  const [modalVisible, setModalVisible] = useState(false)
  // const inputRef = useRef(null)

  const [omiseLoaded, paymentLoading, pay] = useOmiseOffsite('omise_truemoney', publicKey, (err) => {
    const { graphQLErrors } = err
    if (graphQLErrors) {
      graphQLErrors.forEach(error => {
        message.error(intl.formatMessage({ id: `api.${error.message}` }))
      })
    } else if (err.message) {
      message.error(err.message)
    } else {
      message.error(err)
    }
  })
  const handleSubmit = ({ amount, mobileNumber }) => pay('truemoney', registration, {
    amount: finalAmount,
    mobile_number: mobileNumber
  })
  return <Block>
    {omiseLoaded ? <React.Fragment>
      <div className="title">
        <FormattedMessage id="paymentMethod.omise_truemoney" />
      </div>
      <div>
        {systemFee
          ? <React.Fragment>
            <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
              amount: intl.formatNumber(discounted - totalSystemFee)
            }} />
            <FormattedMessage id="app.processingFeeBaht" defaultMessage="Processing Fee {amount} Baht" tagName="div" values={{
              amount: intl.formatNumber(totalSystemFee)
            }} />
          </React.Fragment>
          : <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
            amount: intl.formatNumber(discounted)
          }} />
        }
        <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" values={{
          amount: intl.formatNumber(fee)
        }} />
        {itemsDiscounted > 0 && <FormattedMessage id="app.itemsAmountBaht" defaultMessage="Extra Products {amount} Baht" tagName="div" values={{
          amount: intl.formatNumber(itemsDiscounted)
        }} />}
      </div>
      <Button
        icon="wallet"
        type="primary"
        onClick={() => setModalVisible(true)}
        loading={paymentLoading}
        className="paymentButton"
      >
        <FormattedMessage id="app.payBaht" values={{
          amount: intl.formatNumber(finalAmount)
        }} />
      </Button>
      <TruemoneyModal
        amount={finalAmount}
        visible={modalVisible}
        loading={paymentLoading}
        onClose={() => setModalVisible(false)}
        onSubmit={handleSubmit}
      />
    </React.Fragment>
      : <div className="modLoadding">
        <Spin tip="Loading..." size="large" />
      </div>}
  </Block>
})

export default OmiseTruemoney



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/OmiseTruemoney/OmiseTruemoney.js